// src/utils/platform.ts
import { Capacitor } from "@capacitor/core";
import { AppTrackingTransparency } from 'capacitor-app-tracking-transparency';



type Platform = "ios" | "android" | "web" | "unknown";

/**
 * Get the current platform: 'ios', 'android', or 'web'.
 */
export function getPlatform(): Platform {
    try {
        const platform = Capacitor.getPlatform();
        if (["ios", "android", "web"].includes(platform)) {
            return platform as Platform;
        }
    } catch (error) {
        console.error("Error getting platform:", error);
    }
    return "unknown";
}

/**
 * Returns true if the app is running on Android.
 */
export function isAndroid(): boolean {
    return getPlatform() === "android";
}

/**
 * Returns true if the app is running on iOS.
 */
export function isIOS(): boolean {
    return getPlatform() === "ios";
}

/**
 * Returns true if the app is running in a web browser.
 */
export function isWeb(): boolean {
    return getPlatform() === "web";
}

export async function requestTrackingPermission() {
    try {
        console.log('🔄 Requesting App Tracking Transparency permission...');
        const { status } = await AppTrackingTransparency.getStatus();
        console.log('Tracking status:', status);

        if (status === 'notDetermined') {
            const { status: newStatus } = await AppTrackingTransparency.requestPermission();
            console.log('Nuevo status de tracking:', newStatus);
        }
    } catch (error) {
        console.error('❌ Error requesting App Tracking Transparency permission:', error);
    }
}